<style scoped="scoped" lang="scss">
/deep/ .dialog-scroller {
  overflow: auto;
  position: relative;
  height: calc(80vh - 550px);
}

.overview {
  margin-left: 22px;

  .overview-target {
    margin-left: -22px;
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    // 左侧
    .left {
      display: flex;
      align-items: center;

      .icon {
        display: inline-block;
        width: 5px;
        height: 16px;
        background: #419FFF;
      }

      .txt {
        display: inline-block;
        font-weight: 400;
        font-size: 16px;
        color: #303133;
        margin-left: 12px;
      }

    }

    // 右侧
    .middle {
      display: flex;
      align-items: center;
      margin-left: 148px;

      .icon {
        display: inline-block;
        width: 5px;
        height: 16px;
        background: #419FFF;
      }

      .txt {
        display: inline-block;
        font-weight: 400;
        font-size: 16px;
        color: #303133;
        margin-left: 12px;
      }
    }

    // 右侧
    .right {
      float: right;
    }
  }

  .box-wrap {
    margin-left: -22px;
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 1118px;
    min-height: 100px;

    .box-line {
      width: 24px;
      height: 100%;
    }

    .box-item {
      flex: 1;
      min-width: 553px;
      min-height: 100px;
      border: 1px solid #E4E7ED;

      .left-content {
        display: flex;
        flex-wrap: wrap;
        padding: 20px;
        color: #303133;
        font-size: 16px;
        justify-content: space-between;
        align-items: center;

        .left-item {
          flex-basis: calc(50% - 30px); /* 20px是元素之间的间隔 */
          margin-right: 10px;

        }
      }
    }


  }

  .chart-box {
    //padding: 15px;
    margin-left: -22px;
    margin-top: 12px;
    min-width: 1118px;
    min-height: 251px;
    display: flex; /* 设置为flex布局 */
    flex-direction: row; /* 设置为水平排列 */
    justify-content: space-between; /* 设置为两端对齐 */
    .box-line {
      width: 24px;
      height: 100%;
    }

    .chart-left, .chart-right {
      box-sizing: border-box; /* 设置盒子模型为border-box */
      height: 251px; /* 设置高度 */
      //border: 1px solid red; /* 设置背景色 */
    }

    .chart-left {
      float: left; /* 设置为左浮动 */
      width: 50%; /* 设置宽度为50% */
      .text-title {
        color: #303133;
      }

      #efficiencyChat {
        //margin: 20px;
        overflow: auto;
        width: 100%;
        height: 251px;
      }
    }

    .chart-right {
      float: right; /* 设置为右浮动 */
      width: 50%; /* 设置宽度为50% */
      .text-title {
        color: #303133;
      }

      #yearChat {
        //margin: 20px;
        overflow: auto;
        width: 100%;
        height: 251px;
      }
    }
  }

  .chart1-box {
    //padding: 15px;
    margin-left: -22px;
    margin-top: 70px;
    min-width: 1118px;
    min-height: 251px;
    display: flex; /* 设置为flex布局 */
    flex-direction: row; /* 设置为水平排列 */
    justify-content: space-between; /* 设置为两端对齐 */
    .box-line1 {
      width: 24px;
      height: 100%;
    }

    .chart-left1, .chart-right1 {
      box-sizing: border-box; /* 设置盒子模型为border-box */
      height: 251px; /* 设置高度 */
      border: 1px solid #E4E7ED; /* 设置背景色 */
    }

    .chart-left1 {
      float: left; /* 设置为左浮动 */
      width: 50%; /* 设置宽度为50% */
      .text-title1 {
        margin-top: -30px;
        display: flex;
        align-items: center;
        color: #303133;

        .icon {
          display: inline-block;
          width: 5px;
          height: 16px;
          background: #419FFF;
        }

        .text {
          display: inline-block;
          font-weight: 400;
          font-size: 16px;
          color: #303133;
          margin-left: 12px;
        }

        //margin-left: 12px;
      }

      .item-title {
        font-size: 16px;
        color: #303133;
        font-family: Microsoft YaHei UI;
        margin-left: 15px;
        margin-top: 30px;
      }

    }

    .chart-right1 {
      float: right; /* 设置为右浮动 */
      width: 50%; /* 设置宽度为50% */
      .text-title1 {
        margin-top: -30px;
        display: flex;
        align-items: center;
        color: #303133;

        .icon {
          display: inline-block;
          width: 5px;
          height: 16px;
          background: #419FFF;
        }

        .text {
          display: inline-block;
          font-weight: 400;
          font-size: 16px;
          color: #303133;
          margin-left: 12px;
        }
      }

      .wrap_box {
        min-width: 500px;
        min-height: 200px;
        display: flex; /* 设置为flex布局 */
        flex-direction: row; /* 设置为水平排列 */
        justify-content: space-between; /* 设置为两端对齐 */
        .box1, .box2 {
          box-sizing: border-box; /* 设置盒子模型为border-box */
          height: 251px; /* 设置高度 */
          //border: 1px solid red; /* 设置背景色 */
        }

        .box1 {
          float: left; /* 设置为左浮动 */
          width: 50%; /* 设置宽度为50% */
          padding: 15px;
          #rightApp {
            width: 100%;
            height: 250px;
          }
        }

        .box2 {
          float: right; /* 设置为右浮动 */
          width: 50%; /* 设置宽度为50% */
          padding: 15px;
          #rightAppTwo {
            width: 100%;
            height: 250px;
          }
        }
      }
    }
  }
}

</style>
<template>
  <div style="display: inline;">
    <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt"></yi_curd_table>
    <div class="overview">
      <div class="overview-target">
        <div class="left">
          <span class="icon"></span>
          <span class="txt">{{$t('zuorikaijilujiadonglu')}}（{{yesterday}}）</span>
          <span style="color: #419FFF">{{$t('meiri9:00gengxinzuorishuju')}}</span>
        </div>
        <div class="middle">
          <span class="icon"></span>
          <span class="txt">{{$t('jinyiniankaijilujiadonglu')}}（{{yearStart}} - {{yesterday}}）</span>
        </div>
        <div class="right">
          <!--筛选设备-->

          <!--          <el-button type="primary" size="mini"  @click="setUp" plain>{{$t('shaixuanshebei')}}</el-button>-->
        </div>
        <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
            :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
          <template v-if="yt.editObj.action == 'shezhi'">
            <div class="dialog-scroller">
              <el-transfer style="display: flex;justify-content: center;align-items: center"
                  :titles="[$t('shebeiliebiao'), $t('xuanzhongshebei')]"
                  v-model="selectEquipment"
                  @change="handleChange"
                  :data="equipmentList"
                  :props="{key: 'id',label: 'name'}">
              </el-transfer>
            </div>
            <template slot="footer" class="dialog-footer">
              <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
              <el-button size="mini" @click="setBatchEquipmentBoard" type="primary">{{$t('baocun')}}
              </el-button>
            </template>
          </template>
        </el-dialog>

      </div>
      <div class="box-wrap">
        <!--设备开机率-->
        <div class="box-item">
          <div class="left-content">
            <span class="left-item">
              {{$t('shebeikaijilu')}}
              <span style="margin-left: 8px;color: #303133;font-size: 24px">{{startupRate}}%</span>
            </span>
            <span class="left-item">
              {{$t('shebeijiadonglu')}}

              <span style="margin-left: 8px;color: #303133;font-size: 24px">{{runRate}}%</span>
            </span>
            <span class="left-item" style="margin-top: 25px">
               <!--设备开机率 昨日开机率 – 前日开机率-->
              {{$t('bishangyiri')}}
              <span style="margin-left: 8px;color: #303133;font-size: 24px">
               <i v-if="(startupRate - yStartupRate)>0" style="color: #F56C6C" class="el-icon-top"></i>
               <i v-if="(startupRate - yStartupRate)<0" style="color: #F56C6C" class="el-icon-bottom"></i>
                {{(startupRate - yStartupRate).toFixed(1)}}%
              </span>
            </span>
            <span class="left-item" style="margin-top: 25px">
              <!--设备稼动率 昨日稼动率 – 前日稼动率-->
              {{$t('bishangyiri')}}
               <span style="margin-left: 8px;color: #303133;font-size: 24px;">
                 <i v-if="(runRate - yRunRate)>0" style="color: #F56C6C" class="el-icon-top"></i>
                 <i v-if="(runRate - yRunRate)<0" style="color: #F56C6C" class="el-icon-bottom"></i>
                {{(runRate - yRunRate).toFixed(1)}}%
              </span>
            </span>
          </div>
        </div>
        <div class="box-line"></div>
        <!--设备稼动率-->
        <div class="box-item">
          <div class="left-content">
            <span class="left-item">
              {{$t('shebeikaijilu')}}
              <span style="margin-left: 8px;color: #303133;font-size: 24px">{{newStartupRate}}%</span>
            </span>
            <span class="left-item">
              {{$t('shebeijiadonglu')}}

              <span style="margin-left: 8px;color: #303133;font-size: 24px">{{newRunRate}}%</span>
            </span>
            <span class="left-item" style="margin-top: 25px">
               <!--设备开机率 昨日开机率 – 前日开机率-->
              {{$t('bishangyinian')}}
              <span style="margin-left: 8px;color: #303133;font-size: 24px">
                 <i v-if="(newStartupRate - yNewStartupRate)>0" style="color: #F56C6C" class="el-icon-top"></i>
                 <i v-if="(newStartupRate - yNewStartupRate)<0" style="color: #F56C6C" class="el-icon-bottom"></i>
                {{(newStartupRate - yNewStartupRate).toFixed(1)}}%
              </span>
            </span>
            <span class="left-item" style="margin-top: 25px">
              <!--设备稼动率 昨日稼动率 – 前日稼动率-->
              {{$t('bishangyinian')}}
               <span style="margin-left: 8px;color: #303133;font-size: 24px;">
                   <i v-if="(newRunRate - yNewRunRate)>0" style="color: #F56C6C" class="el-icon-top"></i>
                 <i v-if="(newRunRate - yNewRunRate)<0" style="color: #F56C6C" class="el-icon-bottom"></i>
                {{(newRunRate - yNewRunRate).toFixed(1)}}%
              </span>
            </span>
          </div>
        </div>
      </div>
      <!--图表-->
      <div class="chart-box">
        <div class="chart-left">
          <div class="text-title">{{$t('jinqiri')}}({{firstItem}}{{$t('zhi4')}}{{lastItem}})</div>
          <div id="efficiencyChat"></div>
        </div>
        <div class="box-line"></div>
        <div class="chart-right">
          <div class="text-title">{{$t('jinliugeyue')}}({{firstYear}}{{$t('zhi4')}}{{lastYear}})</div>
          <div id="yearChat"></div>
        </div>
      </div>
      <!--分布图-->
      <div class="chart1-box">
        <div class="chart-left1">
          <div class="text-title1">
            <span class="icon"></span>
            <span class="text">{{$t('jin30jiadonglu')}}</span>
          </div>
          <div class="item-title">{{$t('yingxiangyinsufenbubiao')}}</div>
          <div style="display: flex;justify-content: space-around">
            <div>
              <div class="echart-leftApp">
                <div style="width:470px;height:133px;" id="leftApp"></div>
              </div>
            </div>
            <div>
              <div style="margin-top: 2px;font-size: 14px">
                <span style="margin-left: -60px;color: #909399;">{{$t('zuiduoyingxiangyinsu')}}</span>
                <span style="margin-left: 12px">{{$t(rightEchart.reasonTypeName)}}</span>
                <span style="margin-left: 12px" v-if="(rightEchart.reason &&rightEchart.reasonTypeName ) !== ''">-</span>
                <span style="margin-left: 12px">{{$t(rightEchart.reason)}}</span>
              </div>
              <div style="margin-top: 20px;font-size: 14px">
                <span style="margin-left: -60px;color: #909399;">{{$t('yingxiangyinsuzhanbi')}}</span>
                <span style="margin-left: 22px">{{rightEchart.ratio}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box-line1"></div>
        <div class="chart-right1">
          <div class="text-title1">
            <span class="icon"></span>
            <span class="text">{{$t('jin30shebeixiaolupaiming')}}</span>
          </div>
          <!--左右-->
          <div class="wrap_box">
            <!--最高开机率-->
            <div class="box1">
              <div style="margin-top: 50px">
                <div id="rightApp"></div>
              </div>
            </div>
            <!--最高稼动率-->
            <div class="box2">
              <div style="margin-top: 50px">
                <div id="rightAppTwo"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      -->

    </div>
  </div>
  <!--    -->
  <!--  </div>-->

</template>

<script type="text/javascript">
export default {
  name: "web_report_efficiency_report_overview",
  props: {
    selectEquipment: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      year: null,
      lastYear: null,
      equipmentList: [],
      // selectEquipment: [],
      equipmentId: [],
      dataList: [],
      newList: [],
      summaryDate: null,
      newSummaryDate: null,
      totalHeightCharts:null,
      runHeightCharts:null,
      yesterday: '',
      startupRate: null,//开机率
      runRate: null,//稼动率
      newStartupRate: null,//开机率
      newRunRate: null,//稼动率
      beforeYesterdayOfYesterday: '',
      yStartupRate: '',
      yRunRate: '',
      yNewStartupRate: '',
      yNewRunRate: '',
      yearStart: '',
      newEfficiencyChat: null,
      allSummaryDate: [],
      firstItem: null,
      lastItem: null,
      firstYear: null,
      // leftEchart: {
      //   equipmentName: '',
      //   time: '',
      //   reason: ''
      // },
      rightEchart: {
        equipmentName: '',
        ratio: '',
        reason: ''
      },
      leftPercent: [],
      rightList: [],
      rightListTwo: [],
    }

  },
  watch: {
    selectEquipment: {
      handler(n) {
        this.getEfficiency()
        this.getNewEfficiency()
        this.getYearEfficiency()
      },
      immediate: false,
      deep: true
    }
  },
  computed: {
    maxJiaDongVal() {
      return Math.max(...this.leftPercent)
    },
  },
  async created() {
    this.utils.event_hub.$on('EFFICENCY_REPORT_OVERVIEW_REFRESHS', () => {
      this.resize()
      setTimeout(() => {
        this.getEfficiency()
      },)
    })
    this.getStartupRate()

    setTimeout(() => {
      this.getEfficiency()
      this.getNewEfficiency()
      this.getYearEfficiency()
      this.getDowntimeReport()
      this.getRunRate()
    }, 0)
  },
  activated() {
    this.resize()
  },
  mounted() {
    this.resize()
    let currentDate = new Date(); // 获取当前日期对象
    let yesterdayDate = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000); // 获取昨天日期对象
    let beforeYesterdayDate = new Date(yesterdayDate.getTime() - 24 * 60 * 60 * 1000); // 获取昨日前一日日期对象
    let yearStart = new Date(currentDate.getFullYear(), 0, 1);
    this.today = this.formatDate(currentDate); // 格式化当前日期
    this.yearStart = this.formatDate(yearStart)
    this.yesterday = this.formatDate(yesterdayDate); // 格式化昨天日期
    this.beforeYesterdayOfYesterday = this.formatDate(beforeYesterdayDate); // 格式化昨日前一日日期
    this.currentDate = this.formatDate(currentDate)
    this.year = currentDate.getFullYear();
    this.lastYear = this.year - 1;
  },
  methods: {
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        this.screenWidth = document.body.clientWidth
        if (this.newEfficiencyChat != null) {
          this.newEfficiencyChat.resize()
        }
        if (this.yearEfficiencyChat != null) {
          this.yearEfficiencyChat.resize()
        }
        if(this.totalHeightCharts !=null) {
          this.totalHeightCharts.resize()
        }
        if(this.runHeightCharts !==null) {
          this.runHeightCharts.resize()
        }
      }, 500)
    },
    formatDate(date) {
      let year = date.getFullYear();
      let month = this.padZero(date.getMonth() + 1);
      let day = this.padZero(date.getDate());
      return year + '/' + month + '/' + day;
    },
    padZero(num) {
      return num < 10 ? '0' + num : num;
    },
    //昨日（近7天）
    async getEfficiency() {
      let str = this.selectEquipment.join(',')
      return await this.http.get('/web/report/page/xiaolvbaobiao_zuori?' + this.qs.stringify({
        equipmentId: str,
        // equipmentId: 9251,
        orderBy: 'summaryDate asc',
      })).then(res => {
        this.dataList = res.data.rows
        this.drawEfficiencyChat(res.data.rows)
        if(this.dataList.length >= 1) {
          let yesterdayData =  this.dataList[this.dataList.length-1]
          this.startupRate = (yesterdayData['startupRate']).toFixed(1)
          this.runRate = (yesterdayData['runRate']).toFixed(1)
        }
        if(this.dataList.length >= 2) {
          let beforeYesterdayData =  this.dataList[this.dataList.length-2]
          this.yStartupRate = (beforeYesterdayData['startupRate']).toFixed(1)
          this.yRunRate = (beforeYesterdayData['runRate']).toFixed(1)
        }
      })
    },
    dateFormat(time) {
      const t = new Date(time)
      // 日期格式
      const format = 'Y/m/d'
      let year = t.getFullYear()
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1
      let day = t.getDate()

      month = month > 9 ? month : `0${month}`
      day = day > 9 ? day : `0${day}`
      const hash = {
        'Y': year,
        'm': month,
        'd': day,
      }
      return format.replace(/\w/g, o => {
        return hash[o]
      })
    },
    dateFormatYear(time) {
      const t = new Date(time)
      // 日期格式
      const format = 'Y年m月'
      let year = t.getFullYear()
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1
      let day = t.getDate()

      month = month > 9 ? month : `0${month}`
      day = day > 9 ? day : `0${day}`
      const hash = {
        'Y': year,
        'm': month,
        'd': day,
      }
      return format.replace(/\w/g, o => {
        return hash[o]
      })
    },
    //今年对比
    async getNewEfficiency() {
      let str = this.selectEquipment.join(',')

      return await this.http.get('/web/report/page/xiaolvbaobiao_jinnian_duibi?' + this.qs.stringify({
        equipmentId: str,
        orderBy: 'summaryDate asc',
      })).then(res => {
        this.newList = res.data.rows
        for (let i = 0; i < this.newList.length; i++) {
          this.newSummaryDate = this.newList[i]['summaryDate']
          if (this.year == this.newSummaryDate + '') {
            this.newStartupRate = this.newList[i]['startupRate'].toFixed(1)
            this.newRunRate = this.newList[i]['runRate'].toFixed(1)
            console.log('newSummaryDate', this.newSummaryDate)
          }
          console.log('this.year', this.year)
          console.log('this.year111', this.newSummaryDate + '')
          if (this.lastYear == this.newSummaryDate + '') {
            this.yNewStartupRate = this.newList[i]['startupRate']
            this.yNewRunRate = this.newList[i]['runRate']
            console.log('newSummaryDate', this.newSummaryDate)
          }
        }
      })
    },
    getYearEfficiency() {
      let str = this.selectEquipment.join(',')
      return this.http.get('/web/report/page/xiaolvbaobiao_jinnian?' + this.qs.stringify({
        equipmentId: str,
        orderBy: 'summaryDate asc',
      })).then(res => {
        this.drawYearEfficiencyChat(res.data.rows)
      })
    },
    getDowntimeReport() {
      let date = new Date();
      date.setMonth(date.getMonth() + 1);
      date.setDate(0);
      const firstDay = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-01'
      const lastDay = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      const first = new Date(firstDay).getTime()
      const last = new Date(lastDay).getTime()
      let requestParam = {
        begin: first,
        end: last,
        orderBy: 'startTime',
      }
      return this.http.get('/web/report/exception?' + this.qs.stringify(requestParam))
          .then(response => {
            const data = response.data
            // this.dataList = data
            // 表格
            this.totalTime = data.extend.totalTime || 0
            this.tableData = data.rows
            this.currentTableData = data.rows
            // if (this.tableData.length > 0) {
            //   // 左侧图表
            //   if (data.extend.equipmentPie) {
            //     this.leftEchart.equipmentName = data.extend.equipmentPie.longest || ''
            //     this.leftEchart.time = data.extend.equipmentPie.times || ''
            //     this.leftEchart.reason = data.extend.equipmentPie.maxReason.reasonName || ''
            //     this.leftEchart.reasonTypeName = data.extend.equipmentPie.maxReason.typeName || ''
            //     if (data.extend.equipmentPie.pie) {
            //       const leftPieData = data.extend.equipmentPie.pie.map(item => {
            //         return {
            //           name: this.$t(item.equipmentName),
            //           value: ((item.count) / 3600).toFixed(1),
            //           code: item.equipmentName
            //         }
            //       })
            //       console.log('leftPieData', leftPieData)
            //       this.$nextTick(() => {
            //         this.drawLeftChart(leftPieData)
            //       })
            //     }
            //   } else {
            //
            //   }
            // }
            // 右侧图表
                if (this.tableData.length > 0) {
                  if (data.extend.reasonPie) {
                    this.rightEchart.equipmentName = data.extend.reasonPie.highest ?this.$t(data.extend.reasonPie
                        .highest).join(
                            " ") : ''
                    this.rightEchart.reason = data.extend.reasonPie.longest.reasonName ?this.$t(data.extend.reasonPie
                        .longest)
                        .reasonName : ''

                    this.rightEchart.reasonTypeName = data.extend.reasonPie.longest.typeName ?this.$t(data.extend
                        .reasonPie
                        .longest
                        .typeName) : ''
                    this.rightEchart.ratio = ((data.extend.reasonPie.ratio) * 100).toFixed(1) + '%'

                    if (data.extend.reasonPie.pie) {
                      const rightPieData = data.extend.reasonPie.pie.map(item => {
                        return {
                          name: this.$t(item.reasonName),
                          value: ((item.count) / 3600).toFixed(1),
                          code:this.$t(item.reasonName),
                        }
                      })
                      this.$nextTick(()=>{

                        this.drawLeftChart(rightPieData)
                      })

                    }
                  } else {
                    this.rightEchart.equipmentName = ''
                    this.rightEchart.reason = ''
                    this.rightEchart.reasonTypeName = ''
                    this.rightEchart.ratio = 0 + '%'
                    this.$nextTick(()=>{

                      this.drawLeftChart([])
                    })
                  }
                }

          }).catch(error => {
            this.$message.error(error)
          })
    },
    //最高开机率
    getStartupRate() {
      return this.http.get('/web/report/page/xiaolvbaobiao_kaijilvzuigao?' + this.qs.stringify({
        pageSize: 3
      })).then(res => {
        this.rightList = res.data.rows
        const rightEchart = this.rightList.map(item => {
          return {
            name: this.$t(item.equipmentName),
            value: item.startupRate,
          }
        })
        this.$nextTick(() => {
          this.drawRightEchart(rightEchart)
        })
      })
    },
    //最高稼动率
    async getRunRate() {
      let arr = await this.selectEquipment
      let str = arr.join(',')

      return await this.http.get('/web/report/page/xiaolvbaobiao_jiadonlvzuigao?' + this.qs.stringify({
        pageSize: 3,
        equipmentId: str
      })).then(res => {
        this.rightListTwo = res.data.rows
        const rightEchartTwo = this.rightListTwo.map(item => {
          return {
            name: this.$t(item.equipmentName),
            value: item.runRate,
          }
        })
        console.log('rightEchart', rightEchartTwo)
        this.$nextTick(() => {
          this.drawRightEchartTwo(rightEchartTwo)
        })
      })
    },
    //稼动率最高
    drawRightEchartTwo(data=[]) {
      this.runHeightCharts = this.echarts.getInstanceByDom(document.getElementById("rightAppTwo"))
      if (this.runHeightCharts == null) {
        this.runHeightCharts = this.echarts.init(document.getElementById("rightAppTwo"));
      }
      if (data.length === 0) {
        this.runHeightCharts.dispose()
        return true
      }
      const xAxis = []
      const startupRate = []
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          if (!xAxis.includes(data[i]['name'])) {
            xAxis.push(data[i]['name'])
          }
          startupRate.push((data[i]['value']).toFixed(2))
        }
      }
      let option = {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          left: 'center',
          top: '0%',
          textStyle: {
            color: '#909399',
            fontSize: 12,
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25,
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '80',
          top: '30%',
          containLabel: true,
        },
        xAxis: {
          show: true,
          type: 'category',
          nameLocation: 'end',
          nameTextStyle: {
            fontSize: 14,
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed',
              color: '#000',
              width: 1,
            },
          },
          axisTick: {
            show: true,
            alignWithLabel: false,
            interval: 'auto',
            inside: false,
            length: 5,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399',
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399',
            },
          },
          axisLabel: {
            margin: 8,
            interval: 'auto',
            rotate: 0,
            fontSize: 14,
            color: '#909399',
          },
          data: xAxis,
        },
        yAxis: [
          {
            type: 'value',
            name: '',
            nameLocation: 'start',
            axisLabel: {
              show: true,
              color: '#4e5b5f',
              formatter: function (val) {
                return val + '%';
              }
            }
          },

        ],
        series: [
          {
            name: this.$t('jiadonglu'),
            type: 'bar',
            barWidth: '12px',
            label: {
              normal: {
                show: true,
                position: 'top',
                formatter: '{c}%',
                color: '#5C41FF',
              },
            },
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#5C41FF',
                },
                  {
                    offset: 1,
                    color: 'rgba(227, 227, 227,0.3)',
                  },
                ]),
                barBorderRadius: 6,
              },
            },
            barGap: '80%',
            barCategoryGap: '100%',
            data: startupRate
          },
        ]
      }
      this.runHeightCharts.setOption(option);

    },
    //最高开机率
    drawRightEchart(data=[]) {
      this.totalHeightCharts = this.echarts.getInstanceByDom(document.getElementById("rightApp"))
      if (this.totalHeightCharts == null) {
        this.totalHeightCharts = this.echarts.init(document.getElementById("rightApp"));
      }
      // totalReportCharts
      if (data.length === 0) {
        this.totalHeightCharts.dispose()
        return true
      }
      const xAxis = []
      const startupRate = []
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          if (!xAxis.includes(data[i]['name'])) {
            xAxis.push(data[i]['name'])
          }
          startupRate.push((data[i]['value']))
        }
      }
      let option = {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          left: 'center',
          top: '0%',
          textStyle: {
            color: '#909399',
            fontSize: 12,
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25,
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '80',
          top: '30%',
          containLabel: true,
        },
        xAxis: {
          show: true,
          type: 'category',
          nameLocation: 'end',
          nameTextStyle: {
            fontSize: 14,
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed',
              color: '#000',
              width: 1,
            },
          },
          axisTick: {
            show: true,
            alignWithLabel: false,
            interval: 'auto',
            inside: false,
            length: 5,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399',
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399',
            },
          },
          axisLabel: {
            margin: 8,
            interval: 'auto',
            rotate: 0,
            fontSize: 14,
            color: '#909399',
          },
          data: xAxis,
        },
        yAxis: [
          {
            type: 'value',
            name: '',
            nameLocation: 'start',
            axisLabel: {
              show: true,
              color: '#4e5b5f',
              formatter: function (val) {
                return val + '%';
              }
            }
          },
        ],
        series: [
          {
            name: this.$t('kaijilu'),
            type: 'bar',
            barWidth: '12px',
            label: {
              normal: {
                show: true,
                position: 'top',
                formatter: '{c}%',
                color: '#43A0FF',
              },
            },
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#419FFF',
                },
                  {
                    offset: 1,
                    color: 'rgba(227, 227, 227,0.3)',
                  },
                ]),
                barBorderRadius: 6,
              },
            },
            barGap: '80%',
            barCategoryGap: '100%',
            data: startupRate
          },
        ]
      }
      this.totalHeightCharts.setOption(option);

    },
    drawLeftChart(data) {
      if (!document.getElementById("leftApp")) {
        return
      }
      let myChart = this.echarts.getInstanceByDom(document.getElementById("leftApp"))
      if (myChart == null) {
        myChart = this.echarts.init(document.getElementById("leftApp"));
      }
      // let option = {
      //   color: ['#76B8FE', '#B09BFE', '#EFA1C5', '#EFE7A1', '#EFBDA1', '#E5E5E5', '#e7bcf3', '#8378ea'],
      //   tooltip: {
      //     trigger: 'item',
      //     formatter: "{a} <br/>{b} : {c}小时 ({d}%)"
      //   },
      //   toolbox: {
      //     show: true,
      //   },
      //   legend: {
      //     itemlength: 8,
      //     itemWidth: 8,
      //     orient: 'vertical',
      //     align: 'left',
      //     left: '33%',
      //     icon: "circle",
      //     textStyle: {
      //       color: '#909399'
      //     },
      //   },
      //   series: [{
      //     label: {
      //       show: false,
      //       formatter: (data) => {
      //         this.leftPercent.push(data.percent)
      //         return data
      //       }
      //     },
      //     name: this.$t('jiadonglu'),
      //     type: 'pie',
      //     center: [80, 65],
      //     data: data
      //   }]
      // };
      let option = {
        color: ['#76B8FE', '#B09BFE', '#EFA1C5', '#EFE7A1', '#EFBDA1', '#E5E5E5', '#e7bcf3', '#8378ea'],
        // let unit = %
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c}小时 ({d}%)"
          // 	formatter: (data) => {
          // 		console.log(data)
          // 		return data.name + "<br/>"+ data.value+ " : " + data.unit;
          // },

        },
        toolbox: {
          show: true,
        },
        legend: {
          itemlength: 8,
          itemWidth: 8,
          orient: 'vertical',
          left: '33%',
          align: 'left',
          icon: "circle",
          textStyle: {
            color: '#909399'
          },
          // formatter: function(params) {
          // 	if (params.indexOf('\n') == -1) {
          // 		return params;
          // 	} else {
          // 		return '{white|' + params.split('\n')[0] + '}\n' + params.split('\n')[1];
          // 	}
          // }
        },
        series: [{
          label: {
            show: false,
          },
          name: this.$t('jiadonglu'),
          type: 'pie',
          center: [80, 65],
          data: data
        }]
      };
      if (data.length == 0) {
        myChart.clear()
        this.currentTableData = undefined
      } else {
        myChart.setOption(option);
        myChart.on('click', this.clickLeftPie)
      }
    },
    drawEfficiencyChat(data = [], obj = {}) {
      this.resize()
      if (!document.getElementById("efficiencyChat")) {
        return
      }
      this.newEfficiencyChat = this.echarts.getInstanceByDom(document.getElementById("efficiencyChat"))
      if (this.newEfficiencyChat == null) {
        this.newEfficiencyChat = this.echarts.init(document.getElementById("efficiencyChat"));
      }
      // let series = []
      // let xAxis = []
      // let seriesData = {}
      if (data.length > 0) {
        for (let obj of data) {
          let dateStr = obj.summaryDate;
          let year = dateStr.slice(0, 4);
          let month = dateStr.slice(4, 6);
          let day = dateStr.slice(6, 8);
          let date = new Date(year, month - 1, day);
          obj.timestamp = date.getTime()
        }
        this.firstItem = this.dateFormat(data[0]['timestamp'])
        this.lastItem = this.dateFormat(data[data.length - 1]['timestamp']);
      }
      let xAxis = data.map(item => {
        return this.dateFormat(item.timestamp)
      })
      let lData = data.map(item => {
        return item.startupRate
      })
      let rData = data.map(item => {
        return (item.runRate).toFixed(1)
      })
      let option = {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          left: 'center',
          top: '0%',
          textStyle: {
            color: '#909399',
            fontSize: 12,
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25,
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '60',
          top: '16%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          splitLine: {
            show: false
          },
          data: xAxis,
        },
        yAxis: [
          // {
          //   // type: 'value',
          //   // splitLine: {
          //   //   show: false
          //   // },
          //   // nameLocation: 'middle',
          //   // nameGap: 70
          //   type: 'value',
          //   formatter: function (val) {
          //     return val + '%';
          //   }
          // },
          {
            type: 'value',
            // name: '占比',
            nameLocation: 'start',
            max: 100,
            min: 0,
            interval: 20,
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              color: '#4e5b5f',
              formatter: function (val) {
                return val + '%';
              }
            }
          },
          {
            type: 'value',
            max: 100,//最大值
            min: 0,//最小值
            interval: 20,//间隔
            axisLine: {
              show: false,
              lineStyle: {
                color: '#d9e1e4'
              },
            },
            axisLabel: {
              show: true,
              color: '#fff',
              formatter: function (val) {//百分比显示
                return val;
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('kaijilu'),
            type: 'line',
            showSymbol: false,
            symbol: 'none',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' %';
              }
            },

            lineStyle: {
              color: '#5C41FF'
            },
            itemStyle: {
              color: '#5C41FF',
            },
            color: '#5C41FF',
            // label: {
            //   position: [-35, -20],
            //   show: true,
            //   fontSize: 14,
            //   color: '#FC8452'
            // },
            data: lData
          },

          {
            name: this.$t('jiadonglu'),
            type: 'line',
            showSymbol: false,
            symbol: 'none',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' %';
              }
            },
            lineStyle: {
              color: '#419FFF'
            },
            itemStyle: {
              color: '#419FFF',
            },
            color: '#419FFF',
            // label: {
            //   position: [-35, -20],
            //   show: true,
            //   fontSize: 14,
            //   color: '#FC8452'
            // },
            data: rData
          }
        ]
      };
      this.newEfficiencyChat.setOption(option);
    },
    drawYearEfficiencyChat(data = []) {
      this.resize()
      if (!document.getElementById("yearChat")) {
        return
      }
      this.yearEfficiencyChat = this.echarts.getInstanceByDom(document.getElementById("yearChat"))
      if (this.yearEfficiencyChat == null) {
        this.yearEfficiencyChat = this.echarts.init(document.getElementById("yearChat"));
      }
      // let series = []
      // let xAxis = []
      // let seriesData = {}
      if (data.length > 0) {
        for (let obj of data) {
          let dateStr = obj.summaryDate;
          let year = dateStr.slice(0, 4);
          let month = dateStr.slice(4, 6);
          let day = dateStr.slice(6, 8);
          let date = new Date(year, month - 1, day);
          obj.timestamp = date.getTime()
        }
        this.firstYear = this.dateFormatYear(data[0]['timestamp'])
        this.lastYear = this.dateFormatYear(data[data.length - 1]['timestamp']);
      }
      let xAxis = data.map(item => {
        return this.dateFormatYear(item.timestamp)
      })
      let lData = data.map(item => {
        return item.startupRate
      })
      let rData = data.map(item => {
        return (item.runRate).toFixed(1)
      })
      let option = {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          left: 'center',
          top: '0%',
          textStyle: {
            color: '#909399',
            fontSize: 12,
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25,
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '60',
          top: '16%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          splitLine: {
            show: false
          },
          data: xAxis,
        },
        yAxis: [
          // {
          //   // type: 'value',
          //   // splitLine: {
          //   //   show: false
          //   // },
          //   // nameLocation: 'middle',
          //   // nameGap: 70
          //   type: 'value',
          //   formatter: function (val) {
          //     return val + '%';
          //   }
          // },
          {
            type: 'value',
            // name: '占比',
            nameLocation: 'start',
            max: 100,
            min: 0,
            interval: 20,
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              color: '#4e5b5f',
              formatter: function (val) {
                return val + '%';
              }
            }
          },
          {
            type: 'value',
            max: 100,//最大值
            min: 0,//最小值
            interval: 20,//间隔
            axisLine: {
              show: false,
              lineStyle: {
                color: '#d9e1e4'
              },
            },
            axisLabel: {
              show: true,
              color: '#fff',
              formatter: function (val) {//百分比显示
                return val;
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('kaijilu'),
            type: 'line',
            showSymbol: false,
            symbol: 'none',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' %';
              }
            },

            lineStyle: {
              color: '#5C41FF'
            },
            itemStyle: {
              color: '#5C41FF',
            },
            color: '#5C41FF',
            // label: {
            //   position: [-35, -20],
            //   show: true,
            //   fontSize: 14,
            //   color: '#FC8452'
            // },
            data: lData
          },

          {
            name: this.$t('jiadonglu'),
            type: 'line',
            showSymbol: false,
            symbol: 'none',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' %';
              }
            },
            lineStyle: {
              color: '#419FFF'
            },
            itemStyle: {
              color: '#419FFF',
            },
            color: '#419FFF',
            // label: {
            //   position: [-35, -20],
            //   show: true,
            //   fontSize: 14,
            //   color: '#FC8452'
            // },
            data: rData
          }
        ]
      };
      this.yearEfficiencyChat.setOption(option);
    },

  }
}
</script>

